import { TFunction } from "next-i18next"
import { type TIconName } from "@/core/components/icon/IconUtil"

export enum ContractStatus {
  Pending = 0,
  Active = 1,
  Rejected = 2,
}

export const CONTRACT_STATUS_ICONS: Record<ContractStatus, TIconName> = {
  [ContractStatus.Pending]: "hourglass",
  [ContractStatus.Active]: "check_circle",
  [ContractStatus.Rejected]: "cancel",
}

export const normalizeContractStatus = (
  status: number | null | undefined,
): ContractStatus => {
  if (status === null || status === undefined || Number.isNaN(status)) {
    return ContractStatus.Pending
  }
  switch (status) {
    case ContractStatus.Pending:
      return ContractStatus.Pending
    case ContractStatus.Active:
      return ContractStatus.Active
    case ContractStatus.Rejected:
      return ContractStatus.Rejected
    default:
      return ContractStatus.Pending
  }
}

export const getContractStatusSelectOptions = (t: TFunction) =>
  [ContractStatus.Pending, ContractStatus.Active, ContractStatus.Rejected].map(
    (status) => ({
      label: t(`common:contract_status.${ContractStatus[status]}`),
      value: String(status),
      icon: CONTRACT_STATUS_ICONS[status],
    }),
  )
